import { render, staticRenderFns } from "./CreateAfterSale.vue?vue&type=template&id=396c0ca6&scoped=true&"
import script from "./CreateAfterSale.vue?vue&type=script&lang=js&"
export * from "./CreateAfterSale.vue?vue&type=script&lang=js&"
import style0 from "./CreateAfterSale.vue?vue&type=style&index=0&id=396c0ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396c0ca6",
  null
  
)

export default component.exports